var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Vector as olLayerVector } from 'ol/layer';
import { Vector as olSourceVector } from 'ol/source';
import { Style, Fill, Stroke, Circle } from 'ol/style';
import { Draw, Modify, Snap } from 'ol/interaction';
import { createBox } from 'ol/interaction/Draw';
import React from 'react';
import PropTypes from 'prop-types';
import { ensureMap } from '../hocs/ensureMap';
import { provideMapState } from '../hocs/provideMapState';

var defaultFontColor = 'rgb(255, 255, 255)';
var defaultFillColor = 'rgb(238, 153, 0)';
var defaultOpacity = 100;
var defaultPointRadius = 10;
var defaultStrokeWidth = 2;

var defaultModifyCircleFillColor = 'rgb(27, 140, 247)';
var defaultModifyCircleStrokeColor = 'rgb(27, 140, 247)';
var defaultModifyCircleRadius = 5;
var defaultModifyFillColor = 'rgb(27, 140, 247)';
var defaultModifyStrokeColor = 'rgb(27, 140, 247)';
var defaultLineDash = [];
var defaultLineDashOffset = 0;

var LayerStyle = PropTypes.shape({
  pointRadius: PropTypes.number,
  fillColor: PropTypes.string,
  fillOpacity: PropTypes.number,
  strokeColor: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWidth: PropTypes.number,
  modifyCircleFillOpacity: PropTypes.number,
  modifyCircleStrokeOpacity: PropTypes.number,
  modifyCircleStrokeColor: PropTypes.string,
  modifyCircleRadius: PropTypes.number,
  modifyCircleFillColor: PropTypes.string,
  modifyFillColor: PropTypes.string,
  modifyFillOpacity: PropTypes.number,
  modifyStrokeColor: PropTypes.string,
  modifyStrokeOpacity: PropTypes.number,
  lineDash: PropTypes.array,
  lineOffset: PropTypes.number
});

function hexToRGB(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity / 100 + ')';
}

function createRGB(rgb, opacity) {
  if (rgb.indexOf('rgb') > -1) {
    return rgb;
  }
  return 'rgba(' + rgb.replace(/\s/g, ',') + ', ' + opacity / 100 + ')';
}

function convertColor(value, opacity) {
  if (value.indexOf('#') > -1) {
    return hexToRGB(value, opacity);
  } else {
    return createRGB(value, opacity);
  }
}

function getFeatureStyle(featureStyle) {
  featureStyle = featureStyle || {};
  var _featureStyle = featureStyle,
      pointRadius = _featureStyle.pointRadius,
      fillColor = _featureStyle.fillColor,
      fillOpacity = _featureStyle.fillOpacity,
      strokeColor = _featureStyle.strokeColor,
      strokeOpacity = _featureStyle.strokeOpacity,
      strokeWidth = _featureStyle.strokeWidth,
      fontColor = _featureStyle.fontColor,
      modifyCircleFillColor = _featureStyle.modifyCircleFillColor,
      modifyCircleStrokeColor = _featureStyle.modifyCircleStrokeColor,
      modifyCircleRadius = _featureStyle.modifyCircleRadius,
      modifyCircleFillOpacity = _featureStyle.modifyCircleFillOpacity,
      modifyCircleStrokeOpacity = _featureStyle.modifyCircleStrokeOpacity,
      modifyFillColor = _featureStyle.modifyFillColor,
      modifyStrokeColor = _featureStyle.modifyStrokeColor,
      modifyFillOpacity = _featureStyle.modifyFillOpacity,
      modifyStrokeOpacity = _featureStyle.modifyStrokeOpacity,
      modifyStrokeWidth = _featureStyle.modifyStrokeWidth,
      lineDash = _featureStyle.lineDash,
      lineDashOffset = _featureStyle.lineDashOffset;


  return {
    strokeWidth: strokeWidth || defaultStrokeWidth,
    strokeColor: convertColor(strokeColor || fillColor || defaultFillColor, strokeOpacity || defaultOpacity),
    fillColor: convertColor(fillColor || defaultFillColor, fillOpacity || defaultOpacity),
    fontColor: convertColor(fontColor || defaultFontColor),
    pointRadius: pointRadius || defaultPointRadius,
    modifyCircleRadius: modifyCircleRadius || defaultModifyCircleRadius,
    modifyCircleFillColor: convertColor(modifyCircleFillColor || defaultModifyCircleFillColor, modifyCircleFillOpacity || defaultOpacity),
    modifyCircleStrokeColor: convertColor(modifyCircleStrokeColor || defaultModifyCircleStrokeColor, modifyCircleStrokeOpacity || defaultOpacity),
    modifyFillColor: convertColor(modifyFillColor || defaultModifyFillColor, modifyFillOpacity || defaultOpacity),
    modifyStrokeColor: convertColor(modifyStrokeColor || defaultModifyStrokeColor, modifyStrokeOpacity || defaultOpacity),
    modifyStrokeWidth: modifyStrokeWidth || defaultStrokeWidth,
    lineDash: lineDash || defaultLineDash,
    lineDashOffset: lineDashOffset || defaultLineDashOffset
  };
}

export var DrawLayer = function (_React$Component) {
  _inherits(DrawLayer, _React$Component);

  function DrawLayer() {
    _classCallCheck(this, DrawLayer);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DrawLayer.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        map = _props.map,
        olGeomType = _props.olGeomType;
    var featureStyle = this.props.featureStyle;

    featureStyle = getFeatureStyle(featureStyle);

    if (map._drawLayers && map._drawLayers[this.id]) {
      map._drawLayers[this.id].layer.setVisible(true);
    }

    map._drawLayers = map._drawLayers || {};

    var layerSource = new olSourceVector();

    var layer = new olLayerVector({
      source: layerSource,
      style: new Style({
        fill: new Fill({
          color: featureStyle.fillColor
        }),
        stroke: new Stroke({
          color: featureStyle.strokeColor,
          width: featureStyle.strokeWidth
        }),
        image: new Circle({
          fill: new Fill({
            color: featureStyle.fillColor
          }),
          stroke: new Stroke({
            color: featureStyle.strokeColor,
            width: featureStyle.strokeWidth
          }),
          radius: featureStyle.pointRadius
        })
      })
    });

    var drawInt = undefined;

    if (olGeomType == 'DrawBox') {
      drawInt = new Draw({
        source: layerSource,
        type: 'Circle',
        geometryFunction: createBox(),
        style: new Style({
          fill: new Fill({
            color: featureStyle.modifyFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyStrokeColor,
            width: featureStyle.modifyStrokeWidth,
            lineDash: featureStyle.lineDash,
            lineDashOffset: featureStyle.lineDashOffset
          }),
          image: new Circle({
            radius: featureStyle.modifyCircleRadius,
            fill: new Fill({
              color: featureStyle.modifyCircleFillColor
            }),
            stroke: new Stroke({
              color: featureStyle.modifyCircleStrokeColor,
              width: featureStyle.modifyCircleStrokeWidth
            })
          })
        })
      });
    } else {
      drawInt = new Draw({
        source: layerSource,
        type: olGeomType,
        style: new Style({
          fill: new Fill({
            color: featureStyle.modifyFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyStrokeColor,
            width: featureStyle.modifyStrokeWidth,
            lineDash: featureStyle.lineDash,
            lineDashOffset: featureStyle.lineDashOffset
          }),
          image: new Circle({
            radius: featureStyle.modifyCircleRadius,
            fill: new Fill({
              color: featureStyle.modifyCircleFillColor
            }),
            stroke: new Stroke({
              color: featureStyle.modifyCircleStrokeColor,
              width: featureStyle.modifyCircleStrokeWidth
            })
          })
        })
      });
    }
    var modifyInt = new Modify({
      source: layerSource,
      style: new Style({
        image: new Circle({
          radius: featureStyle.modifyCircleRadius,
          fill: new Fill({
            color: featureStyle.modifyCircleFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyCircleStrokeColor,
            width: featureStyle.modifyCircleStrokeWidth
          })
        })
      })
    });

    var snapInt = new Snap({
      source: layerSource
    });

    map._drawLayers[this.id] = {
      layer: layer,
      layerSource: layerSource,
      drawInt: drawInt,
      modifyInt: modifyInt,
      snapInt: snapInt
    };

    this.mountLayer();
  };

  DrawLayer.prototype.bindListeners = function bindListeners() {
    var _props2 = this.props,
        map = _props2.map,
        onDrawend = _props2.onDrawend,
        onModifyend = _props2.onModifyend;
    var _map$_drawLayers$id = map._drawLayers[this.id],
        layerSource = _map$_drawLayers$id.layerSource,
        drawInt = _map$_drawLayers$id.drawInt,
        modifyInt = _map$_drawLayers$id.modifyInt;

    drawInt.on('drawend', function (evt) {
      setTimeout(function () {
        onDrawend(evt.feature);
      }, 50);
      // onDrawend(evt.feature);
      // this.isDrawing = false;
    });

    drawInt.on('drawstart', function () {
      // this.isDrawing = true;
      layerSource.clear();
    });

    modifyInt.on('modifyend', function (evt) {
      var f = evt.features.getArray()[0];
      evt.features.forEach(function (fs) {
        if (fs.getRevision() > f.getRevision()) {
          f = fs;
        }
      });
      setTimeout(function () {
        return onModifyend(f);
      }, 50);
    });
  };

  DrawLayer.prototype.mountLayer = function mountLayer() {
    var _props3 = this.props,
        map = _props3.map,
        features = _props3.features;


    if (!map) {
      setTimeout(this.mountLayer.bind(this), 200);
      return;
    }

    var _map$_drawLayers$id2 = map._drawLayers[this.id],
        layer = _map$_drawLayers$id2.layer,
        drawInt = _map$_drawLayers$id2.drawInt,
        modifyInt = _map$_drawLayers$id2.modifyInt,
        snapInt = _map$_drawLayers$id2.snapInt;


    this.bindListeners();
    map.addLayer(layer);

    map.addInteraction(drawInt);
    map.addInteraction(modifyInt);
    map.addInteraction(snapInt);

    this.toggleInteractions(this.props);

    this.updateFeatures(features);
  };

  DrawLayer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    // this.updateFeatures(nextProps.features);
    this.toggleInteractions(nextProps);
  };

  DrawLayer.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return !this.isDrawing;
  };

  DrawLayer.prototype.updateFeatures = function updateFeatures(features) {
    var layerSource = this.props.map._drawLayers[this.id].layerSource;

    var newFeatures = [];
    var efs = layerSource.getFeatures();
    features.forEach(function (f) {
      if (efs.length === 0 || !efs.find(function (ef) {
        return ef.ol_uid === f.ol_uid;
      })) {
        newFeatures.push(f);
      }
    });

    if (newFeatures.length === features.length) {
      layerSource.clear();
    }

    layerSource.addFeatures(newFeatures);
  };

  DrawLayer.prototype.toggleInteractions = function toggleInteractions(props) {
    var map = props.map,
        draw = props.draw,
        modify = props.modify,
        snap = props.snap;
    var _map$_drawLayers$id3 = map._drawLayers[this.id],
        drawInt = _map$_drawLayers$id3.drawInt,
        modifyInt = _map$_drawLayers$id3.modifyInt,
        snapInt = _map$_drawLayers$id3.snapInt;


    drawInt.setActive(draw);
    modifyInt.setActive(modify);
    snapInt.setActive(snap);
  };

  DrawLayer.prototype.componentWillUnmount = function componentWillUnmount() {
    var map = this.props.map;
    var _map$_drawLayers$id4 = map._drawLayers[this.id],
        layer = _map$_drawLayers$id4.layer,
        drawInt = _map$_drawLayers$id4.drawInt,
        modifyInt = _map$_drawLayers$id4.modifyInt,
        snapInt = _map$_drawLayers$id4.snapInt;


    map.removeInteraction(modifyInt);
    map.removeInteraction(drawInt);
    map.removeInteraction(snapInt);
    map.removeLayer(layer);
  };

  DrawLayer.prototype.render = function render() {
    var map = this.props.map;

    if (map._drawLayer && map._drawLayer[this.id].layerSource) {
      this.updateFeatures(this.props.features);
    }

    return React.createElement('span', null);
  };

  DrawLayer.prototype.zoomToExtent = function zoomToExtent() {
    var _props4 = this.props,
        fitViewAndZoom = _props4.fitViewAndZoom,
        maxZoom = _props4.maxZoom;

    fitViewAndZoom(this.map._drawLayerSources[this.id].getExtent(), maxZoom);
  };

  _createClass(DrawLayer, [{
    key: 'id',
    get: function get() {
      return this.props.layerName;
    }
  }]);

  return DrawLayer;
}(React.Component);

DrawLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  olGeomType: PropTypes.string.isRequired,
  features: PropTypes.array.isRequired,
  layerName: PropTypes.string.isRequired,
  maxZoom: PropTypes.number,
  modify: PropTypes.bool,
  draw: PropTypes.bool,
  snap: PropTypes.bool,
  onDrawend: PropTypes.func,
  onModifyend: PropTypes.func,
  featureStyle: LayerStyle,
  map: PropTypes.object,
  fitViewAndZoom: PropTypes.func.isRequired
} : {};
export default provideMapState(ensureMap(DrawLayer));